'use client';

import Image from 'next/image';
import Link from '@/components/general/Link/Link';
import { Box } from '@mui/material';
import { GENERAL_PHRASES } from '@/consts/phrases/generalPhrases';
import { useAuthStore } from '@/store/authStore/authStore';
import { getThemeProps } from '@/components/layoutUtil';
import { config } from '@/config';
import { IPhrases } from '@/types/types/page/pages';
import { usePropsPhrases } from '@/utils/phrases/usePropsPhrases';

import footerStyles from '@/styles/modules/Footer.module.css';

export const defaultHeaderLogoSrc = `/images/themes/${config.theme}/logo-header.svg`;
export const defaultFooterLogoSrc = `/images/themes/${config.theme}/logo-footer.svg`;

interface PanelLogoProps {
    position?: 'header' | 'footer';
    phrases?: IPhrases;
}

export const PanelLogo = ({ position = 'header', phrases }: PanelLogoProps) => {
    const { t } = usePropsPhrases(phrases);
    const { loggedIn, subpanelId } = useAuthStore((state) => ({
        loggedIn: state.loggedIn,
        subpanelId: state.subpanelId,
    }));

    const {
        headerLayout: { logos = {} },
    } = getThemeProps();

    const hasSubpanelLogo = loggedIn && subpanelId && logos?.[subpanelId];

    const isHeaderLogo = position === 'header';
    const defaultLogoSrc = isHeaderLogo ? defaultHeaderLogoSrc : defaultFooterLogoSrc;

    const subpanelClassName = hasSubpanelLogo ? 'SubpanelLogo' : '';
    const logoImageSrc = hasSubpanelLogo ? logos[subpanelId] : defaultLogoSrc;

    const panelTitle = t(GENERAL_PHRASES.PANEL_TITLE, { asString: true });

    return (
        <>
            {isHeaderLogo ? (
                <Box className={`HeaderLogo ${subpanelClassName}`}>
                    <Link href="/" passHref>
                        <Image
                            src={logoImageSrc}
                            width="214"
                            height="38"
                            alt={panelTitle}
                            priority
                        />
                    </Link>
                </Box>
            ) : (
                <Box
                    className={`${footerStyles.logo} FooterLogo ${subpanelClassName}`}
                    sx={{ pt: [3, 3, 0] }}
                >
                    <Link href="/" passHref>
                        <Image
                            src={logoImageSrc}
                            width="180"
                            height="32"
                            alt={panelTitle}
                            priority
                        />
                    </Link>
                </Box>
            )}
        </>
    );
};
